var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIndustries = function SvgIndustries(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48308"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 7.333h3.667V0H49.5v3.667H66Z",
    "data-name": "Path 45556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.667 7.333h3.667V0H20.167v3.667h16.5Z",
    "data-name": "Path 45557"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.336 84.333V49.498a1.84 1.84 0 0 0-1.836-1.836H77V27.498l-1.61-13.441a3.66 3.66 0 0 0-3.612-3.059h-7.883a3.666 3.666 0 0 0-3.63 3.153l-1.577 13.124-.016 20.387h-11V27.498l-1.616-13.441a3.66 3.66 0 0 0-3.611-3.059h-7.884a3.666 3.666 0 0 0-3.63 3.153l-1.576 13.124-.016 20.387H22V34.829a1.83 1.83 0 0 0-.88-1.558 1.81 1.81 0 0 0-1.778-.073L4.678 40.53a1.81 1.81 0 0 0-1.008 1.632v42.171H0v3.665h88v-3.665Zm-66.003-7.335h-3.666v-3.665h3.667Zm0-14.667h-3.666v-3.664h3.667Zm11 14.667h-3.666v-3.665h3.667Zm0-14.667h-3.666v-3.664h3.667Zm33 14.667h-3.666v-3.665h3.667Zm0-14.667h-3.666v-3.664h3.667Zm7.333-3.667h3.667v3.667h-3.666Zm3.67 18.334H69.67v-3.669h3.667Z",
    "data-name": "Path 45558"
  }))));
};
export default SvgIndustries;